<template>
<v-layout row wrap>
<!-- <v-flex xs12 sm6 offset-sm3> -->
  <v-flex xs6>
    <v-card class="card--flex-toolbar ma-2" height="95%">
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">충전기 목록</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="$_assign">save</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>
      <v-progress-linear v-show="leftLoading" color="blue" indeterminate height="2" style="margin: 0 auto"/>

      <div style="max-height:70vh;" class="scroll-y">
        <template v-for="charger in chargers">
          <v-card :key="charger.id" :dark="charger.changed ? true : false">
            <v-card-title>{{charger.managementNumber}} : {{charger.place ? charger.place.name : ''}}</v-card-title>
            <v-card-text>
                <draggable v-model="charger.plugs" group="plugs" style="min-height:20px;" :move="$_onMove" ref="targetList" @change="$_onChange($event, charger)">
                  <template v-for="plug in charger.plugs">
                    <v-chip v-if="plug.moved" :key="plug.id" color="primary" text-color="white">
                      {{plug.id}}
                    </v-chip>
                    <v-chip v-else :key="plug.id">
                      {{plug.id}}
                    </v-chip>
                  </template>
                </draggable>
            </v-card-text>
          </v-card>
        </template>
      </div>
    </v-card>
  </v-flex>
  <v-flex xs6>
    <v-card class="card--flex-toolbar ma-2" height="95%">
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">플러그 목록</v-toolbar-title>
      </v-toolbar>

      <v-divider></v-divider>
      <v-progress-linear v-show="rightLoading" color="blue" indeterminate height="2" style="margin: 0 auto"/>

      <v-card-text style="max-height:70vh;" class="scroll-y">
        <draggable v-model="plugs" group="plugs" style="min-height:20px" :move="$_onMove" ref="sourceList" @change="$_onChange($event)">
          <template v-for="plug in plugs">
            <v-chip v-if="plug.moved" :key="plug.id" color="primary" text-color="white">
              {{plug.id}}
            </v-chip>
            <v-chip v-else :key="plug.id">
              {{plug.id}}
            </v-chip>
          </template>
        </draggable>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import draggable from 'vuedraggable'

export default {
  name: 'HelloWorld',
  components: {
    draggable
  },
  data () {
    return {
      chargers: [],
      plugs: [],
      places: [],
      leftLoading: false,
      rightLoading: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getDatas()
    }
  },
  created () {
    this.$emit('title', '구성 (충전기 - 플러그)')
    this.$_getDatas()
  },
  methods: {
    async $_getDatas () {
      this.chargers = []
      this.plugs = []

      try {
        // let [chargersSnapshot, plugsSnapshot] = await Promise.all([this.$fs.collection('chargers').where('group', '==', this.$store.state.session.group).orderBy('managementNumber').get(),
        //  this.$fs.collection('plugs').where('group', '==', this.$store.state.session.group).get()])

        this.leftLoading = true
        let chargersSnapshot = await this.$fs.collection('chargers').where('group', '==', this.$store.state.session.group).orderBy('managementNumber').get()
        this.chargers = []
        chargersSnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data()}`)

          var item = doc.data()
          item.id = doc.id
          item.plugs = []
          this.chargers.push(item)
        }) // forEach

        this.$_getPlugs(this.chargers)
        this.$_getPlaces(this.chargers)
      } catch (error) {
        this.$emit('snackbar', '충전기 - 플러그 정보를 가져오지 못하였습니다.')
        console.log(error)
      }

      this.leftLoading = false
      this.rightLoading = false
    },
    $_getPlugs (chargers) {
      this.rightLoading = true

      this.plugs = []
      this.$fs
        .collection('plugs')
        .where('group', '==', this.$store.state.session.group)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id

            // chargers 에서 ref 가 있는지 확인 후 mapping
            var charger = chargers.find(charger => { // charger
              if (charger.plugRef) {
                if (charger.plugRef.id === item.id) {
                  return charger
                }
              }
              return null
            })

            if (charger) {
              charger.plugs.push(item)
            } else {
              this.plugs.push(item)
            }
          })

          this.rightLoading = false
        })
    },
    $_getPlaces (chargers) {
      this.leftLoading = true

      this.places = []
      this.$fs
        .collection('places')
        .where('group', '==', this.$store.state.session.group)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id

            // chargers 에서 ref 가 있는지 확인 후 mapping
            chargers.forEach(charger => {
              if (charger.placeRef) {
                if (charger.placeRef.id === item.id) {
                  // charger.place = item
                  this.$set(charger, 'place', item)
                }
              }
            })
          })

          this.leftLoading = false
        })
    },
    $_onMove (evt, originalEvent) {
    // console.log('move', evt, evt.relatedContext.component, this.$refs.checkerList, this.$refs.assignedCheckerListEl, this.$refs.assignedCheckerListEl.indexOf(evt.relatedContext.component))

      if (this.$refs.targetList.indexOf(evt.relatedContext.component) >= 0 &&// 타겟이 각 장소의 점검자 목록이면
          evt.relatedContext.list.length >= 1) { // 한명만 할당 할 수 있음
        return false
      }

      return true
    },
    $_onChange (evt, charger) {
      let plug

      if (evt.added) {
        plug = evt.added.element
      } else if (evt.removed) {
        plug = evt.removed.element
      } else if (evt.moved) {
        // plug = evt.moved.element
        return true
      }

      plug.moved = true

      if (charger) {
        charger.changed = true
        charger.plugs = [...charger.plugs] // vue 에서 바로 변형 감지가 안되어 배열 복사하여 UI 바로 업데이트 함.
      }

      return true
    },
    $_assign () {
      let batch = this.$fs.db().batch()

      // 충전기에 이동된 플러그 할당
      this.chargers.forEach(charger => {
        if (charger.changed) {
          let chargerRef = this.$fs.collection('chargers').doc(charger.id)

          if (charger.plugs.length > 0) {
            var newPlugRef = this.$fs.collection('plugs').doc(charger.plugs[0].id)

            batch.update(newPlugRef, {'chargerRef': chargerRef,
              updated: firebase.firestore.FieldValue.serverTimestamp()})

            batch.update(chargerRef, {'plugRef': newPlugRef,
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          } else {
            batch.update(chargerRef, {'plugRef': firebase.firestore.FieldValue.delete(),
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          }
        }
      })

      // 이동된 플러그에서 충전기 정보 삭제
      this.plugs.forEach(plug => {
        if (plug.moved) {
          let plugRef = this.$fs.collection('plugs').doc(plug.id)

          batch.update(plugRef, {'chargerRef': firebase.firestore.FieldValue.delete(),
            updated: firebase.firestore.FieldValue.serverTimestamp()})
        }
      })

      /* // 전체 장소 목록을 반복하면서
      this.chargers.forEach(charger => {
        var chargerRef = this.$fs.collection('chargers').doc(charger.id)

        if (charger.plugRef) {
          batch.update(charger.plugRef, {'chargerRef': firebase.firestore.FieldValue.delete(),
            updated: firebase.firestore.FieldValue.serverTimestamp()})

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        }

        var newPlugRefs = []
        for (var i = 0; i < charger.plugs.length; i++) {
          var newPlugRef = this.$fs.collection('plugs').doc(charger.plugs[i].id)
          newPlugRefs.push(newPlugRef)

          batch.update(newPlugRef, {'chargerRef': chargerRef,
            updated: firebase.firestore.FieldValue.serverTimestamp()})
        }

        if (newPlugRefs.length > 0) {
          batch.update(chargerRef, {'plugRef': newPlugRefs[0],
            updated: firebase.firestore.FieldValue.serverTimestamp()})
        } else {
          batch.update(chargerRef, {'plugRef': firebase.firestore.FieldValue.delete(),
            updated: firebase.firestore.FieldValue.serverTimestamp()})
        }
      }) */

      // Commit the batch
      batch.commit()
        .then(() => {
          this.$emit('snackbar', '저장 되었습니다.')
          console.log('success')

          this.$_getDatas() // reset
        })
        .catch(error => {
          this.$emit('snackbar', '오류발생으로 저장하지 못하였습니다.')
          console.log('error', error)

          this.$_getDatas() // reset
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Plug/PlugAssign.vue